// extracted by mini-css-extract-plugin
export var label = "_iv-2";
export var slideContainer = "_iv-0";
export var slider = "_iv-1";